import { render, staticRenderFns } from "./mergeTables.vue?vue&type=template&id=5d21b943&scoped=true&"
import script from "./mergeTables.vue?vue&type=script&lang=js&"
export * from "./mergeTables.vue?vue&type=script&lang=js&"
import style0 from "./mergeTables.vue?vue&type=style&index=0&id=5d21b943&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d21b943",
  null
  
)

export default component.exports